var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "no-matches" }, [
    _c(
      "div",
      { staticClass: "no-matches--left" },
      [_c("Jon", { attrs: { white: "" } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "no-matches--right" }, [
      _c("div", {
        staticClass: "no-matches--title",
        domProps: { innerHTML: _vm._s(_vm.title) }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "no-matches--content" }, [_vm._t("default")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }